// eslint-disable-next-line import/extensions
import UsersContainer from './users-container';

export default UsersContainer;
